module.exports = __webpack_public_path__ + "img/JeanetteSanchez_140x140_rund.57896fdd.jpg";